import type { AnyAction, Reducer } from "redux";

import { SET_CURRENT_LANGUAGE } from "./constants";
import type { IAppOptions } from "./types"

const initialState: IAppOptions = {
    language: {
        current: localStorage.getItem("currentLanguage") || "ru"
    },
    basePath: `${process.env.REACT_APP_BASE_PATH}`
}

const appOptions: Reducer<IAppOptions, AnyAction> = (state = initialState, action): IAppOptions => {
    switch (action.type) {

        case SET_CURRENT_LANGUAGE: {
            return {
                ...state,
                language: {
                    current: action.payload
                }
            }
        }

        default: return state;
    }
}

export default appOptions;